import { find, isEmpty } from 'lodash';
import {
  KnowledgeKeys,
  KnowledgeKeysByOutcomeType,
  questionnaireLogicService,
  FinalNode,
} from './logic';

Pollfish.store = (function store() {
  return {
    monitoring: {
      rejectedSurveys: {},
      reportedRejectionErrors: false,
      offersImpression: [],
    },
    shuffledAnswers: {},
    userRejectedSurveys: [],
    initRespondentKnowledge(
      respondentKnowledge,
      extraTaxonomyProperties,
      extraQuotasProperties,
    ) {
      this.respondentKnowledge = respondentKnowledge || {
        taxonomyDevice: {},
        quotas: {},
        concepts: [],
        choiceSetBlockIds: [],
        choiceSetBlocks: [],
        questionAnswers: [],
        screeningQuestionAnswers: [],
      };
      this.respondentKnowledge.taxonomyDevice = {
        ...(this.respondentKnowledge.taxonomyDevice || {}),
        ...extraTaxonomyProperties,
      };
      this.respondentKnowledge.quotas = {
        ...(this.respondentKnowledge.quotas || {}),
        ...extraQuotasProperties,
      };
      this.respondentKnowledge[KnowledgeKeys.Variables] = {};
      this.respondentKnowledge[KnowledgeKeys.Visibility] = {};
    },
    getRespondentKnowledge() {
      if (!this.respondentKnowledge) {
        this.respondentKnowledge = {
          taxonomyDevice: {},
          quotas: {},
          concepts: [],
          choiceSetBlockIds: [],
          choiceSetBlocks: [],
          questionAnswers: [],
          screeningQuestionAnswers: [],
          [KnowledgeKeys.Variables]: {},
          [KnowledgeKeys.Visibility]: {},
        };
      }

      return this.respondentKnowledge;
    },
    updateRespondentKnowledgeByKey(key, respondentKnowledge) {
      this.respondentKnowledge = {
        ...this.respondentKnowledge,
        [key]: respondentKnowledge[key],
      };
    },
    updateKnowledgeByAdlOutcomeEvaluation(
      outcomeType,
      nodeRefId,
      questionnaireLogic,
    ) {
      if (nodeRefId === FinalNode || isEmpty(questionnaireLogic)) {
        return;
      }

      const updatedKnowledge = questionnaireLogicService.evaluateKnowledgeForNode(
        questionnaireLogic,
        this.getRespondentKnowledge(),
        nodeRefId,
        [outcomeType],
      );

      this.updateRespondentKnowledgeByKey(
        KnowledgeKeysByOutcomeType[outcomeType],
        updatedKnowledge,
      );
    },
    addTaxonomyData(taxonomy) {
      const respondentKnowledge = this.getRespondentKnowledge();
      respondentKnowledge.taxonomyDevice = { ...taxonomy };
    },
    addQuotasData(quotas) {
      const respondentKnowledge = this.getRespondentKnowledge();
      respondentKnowledge.quotas = { ...quotas };
    },
    addAnsweredConcept(nodeId, concept) {
      const knowledge = this.respondentKnowledge;
      const nodeWithConcept = find(knowledge.concepts, ['nodeId', nodeId]);
      const selectedConceptId = concept.id.toString();

      if (!nodeWithConcept) {
        knowledge.concepts.push({
          nodeId,
          conceptIds: [concept.refId],
          conceptBackEndIds: [selectedConceptId],
        });
        return;
      }

      if (!nodeWithConcept.conceptIds.includes(concept.refId)) {
        nodeWithConcept.conceptIds.push(concept.refId);
        nodeWithConcept.conceptBackEndIds.push(selectedConceptId);
      }
    },
    addAnsweredChoiceSet(nodeRefId, choiceSetId, blockId) {
      const knowledge = this.respondentKnowledge;
      const nodeWithBlock = find(knowledge.choiceSetBlocks, [
        'nodeId',
        nodeRefId,
      ]);
      // const selectedConceptId = concept.id.toString();
      if (!knowledge.choiceSetBlockIds.includes(blockId)) {
        knowledge.choiceSetBlockIds.push(blockId);
      }
      // ΝΟΤΕ: these are not currently used anywhere
      if (!nodeWithBlock) {
        knowledge.choiceSetBlocks.push({
          nodeRefId,
          choiceSetIds: [choiceSetId],
        });
        return;
      }
      if (!nodeWithBlock.choiceSetIds.includes(choiceSetId)) {
        nodeWithBlock.choiceSetIds.push(choiceSetId);
      }
    },
    getIsPreviousPageGDPR() {
      return this.isPreviousPageGDPR;
    },
    setIsPreviousPageGDPR(isGDPR) {
      this.isPreviousPageGDPR = isGDPR;
    },
    setShuffledAnswers(refId, answers) {
      this.shuffledAnswers[refId] = answers;
    },
    getShuffledAnswers(refId) {
      return this.shuffledAnswers[refId];
    },
  };
})();

export default Pollfish.store;
